import { createSlice } from "@reduxjs/toolkit";

import {
  getCurrentUser,
  logoutUser,
  setCurrentUser,
  updateCalculationValues,
} from "./actions";

import { UserStatus } from "constants/enums";

const initialState = {
  user: null,
  isAuthenticated: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setCurrentUser, (state, action) => {
      state.user = action.payload;

      if (action.payload && action.payload.status === UserStatus.ACTIVE) {
        state.isAuthenticated = true;
      } else {
        state.isAuthenticated = false;
      }
    });

    builder.addCase(getCurrentUser.fulfilled, (state, action) => {
      state.user = action.payload;

      state.isAuthenticated =
        action.payload.status === UserStatus.ACTIVE ? true : false;
    });

    builder.addCase(logoutUser, () => {
      return initialState;
    });

    builder.addCase(updateCalculationValues.fulfilled, (state, action) => {
      state.user = {
        ...state.user,
        calculator: action.payload.calculator,
      };
    });
  },
});

export default authSlice.reducer;
